import { Authentication } from "../domain/authentication";

export type AuthenticationFunction = () => Authentication | undefined;